import { Cascader, Modal } from 'antd';
import { useState } from 'react';

interface Props {
  categoryOptions: any[];
  ids: string[];
  selectCategoryId?: string;
  onClose: () => void;
  onChange: (ids: string[], categoryId: string) => void;
}
const ChangeCategoryModal: React.FC<Props> = (props: Props) => {
  const { categoryOptions, ids, onClose, onChange, selectCategoryId } = props;
  const [categoryId, setCategoryId] = useState('');

  const [defaultCategoryIds] = useState<string[]>(() => {
    if (ids.length > 1 || !selectCategoryId) {
      //批量
      return [];
    }
    for (let i = 0; i < categoryOptions.length; i++) {
      const category = categoryOptions[i];
      if (selectCategoryId === category.id) {
        return [category.id];
      }
      for (let j = 0; j < category.children.length; j++) {
        const subCategory = category.children[j];
        if (selectCategoryId === subCategory.id) {
          return [category.id, subCategory.id];
        }
      }
    }
    return [];
  });
  const onCategoryChange = (values: any[]) => {
    if (!values || values.length === 0) {
      setCategoryId('');
      return;
    }
    setCategoryId(values[values.length - 1]);
  };
  const onSubmit = () => {
    onChange(ids, categoryId);
  };
  return (
    <Modal
      visible={true}
      width={416}
      title="修改分类"
      onOk={onSubmit}
      onCancel={onClose}
      okButtonProps={{ disabled: !categoryId }}
      style={{ top: 200 }}
    >
      <div className="flex-ai-center">
        <span style={{ width: '40px' }}>分类</span>
        <Cascader
          // changeOnSelect
          placeholder="请选择分类"
          expandTrigger="hover"
          style={{ width: '100%', maxWidth: '330px' }}
          defaultValue={defaultCategoryIds}
          options={categoryOptions}
          onChange={onCategoryChange}
          fieldNames={{
            label: 'name',
            value: 'id',
            children: 'children',
          }}
        ></Cascader>
      </div>
    </Modal>
  );
};

export default ChangeCategoryModal;
